import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "input" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { class: "button-using" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Добавить новость ")
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "user-table" }
const _hoisted_12 = /*#__PURE__*/_createVNode("th", { width: "100" }, "#", -1)
const _hoisted_13 = { width: "300" }
const _hoisted_14 = { width: "400" }
const _hoisted_15 = { width: "300" }
const _hoisted_16 = { class: "user-edit" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "row justify-content-end" }
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = { class: "pagination" }
const _hoisted_21 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modalcontent" }
const _hoisted_24 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2" }, " Вы действительно хотите удалить данные? ", -1)
const _hoisted_25 = { class: "modalcontent__margin modalcontent__margin-faq" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_main_footer = _resolveComponent("main-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("input", {
              type: "text",
              name: "",
              id: "",
              placeholder: " ID, Заголовок, Краткое описание",
              class: "search-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.data.word = $event)),
              onKeyup: _cache[2] || (_cache[2] = (...args) => (_ctx.endAndStartTimer(...args)))
            }, null, 544), [
              [_vModelText, _ctx.data.word]
            ]),
            _createVNode(_component_svg_icon, { name: "Combined_Shape" })
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "admin-article-create",
            "active-class": "active",
            to: "/admin/article/create",
            exact: ""
          }, {
            default: _withCtx(() => [
              _createVNode("button", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_svg_icon, { name: "Vector" })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("table", _hoisted_11, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _hoisted_12,
                _createVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('admin.title')), 1),
                _createVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('admin.alias')), 1),
                _createVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('admin.operation')), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
                return (_openBlock(), _createBlock("tr", {
                  key: article.id
                }, [
                  _createVNode("td", null, _toDisplayString(article.id), 1),
                  _createVNode("td", null, _toDisplayString(article.title), 1),
                  _createVNode("td", null, _toDisplayString(article.alias), 1),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("button", {
                        class: "news-edit",
                        onClick: $event => (_ctx.articleChange(article.id))
                      }, [
                        _createVNode(_component_svg_icon, { name: "Group_98" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.change')), 1 /* TEXT */)
                      ], 8, ["onClick"]),
                      _createVNode("button", {
                        class: "news-delete",
                        onClick: $event => {
                      ;(_ctx.changeactive = !_ctx.changeactive)((_ctx.articleid = article.id))
                    }
                      }, [
                        _createVNode(_component_svg_icon, { name: "delete" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.delete')), 1 /* TEXT */)
                      ], 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("ul", _hoisted_20, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.linkPage, (page) => {
              return (_openBlock(), _createBlock("li", {
                class: { ['page-active']: page.active },
                key: page.id,
                onClick: $event => (_ctx.pageUser(page.url))
              }, [
                _createVNode("p", {
                  innerHTML: page.label
                }, null, 8, ["innerHTML"])
              ], 10, ["onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createVNode(_component_main_footer),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.changeactive)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.changeactive = !_ctx.changeactive))
                }, "×"),
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode("div", _hoisted_25, [
                    _createVNode("button", {
                      class: "button button--primary form__button form__button1",
                      onClick: _cache[4] || (_cache[4] = $event => (_ctx.removeArticleById(_ctx.articleid)))
                    }, _toDisplayString(_ctx.$t('admin.yes')), 1),
                    _createVNode("button", {
                      class: "button button--primary form__button form__button1",
                      onClick: _cache[5] || (_cache[5] = $event => (_ctx.changeactive = !_ctx.changeactive))
                    }, _toDisplayString(_ctx.$t('admin.no')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
}